/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CourseSectionDivisionUser } from './CourseSectionDivisionUser';
const CreateDivisionSectionDataParser = 
/* #__PURE__ */ parsers.object([
    ['users', /* #__PURE__ */ codecArray(CourseSectionDivisionUser)],
]);
export class CreateDivisionSectionData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateDivisionSectionDataParser.decode(input).map(res => new CreateDivisionSectionData(res));
    }
    static unsafeDecode(input) {
        return CreateDivisionSectionData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateDivisionSectionDataParser.encode(data);
    }
    static schema() {
        return CreateDivisionSectionDataParser.schema();
    }
}
